import { en } from './catalogs/en.js';
import { ru } from './catalogs/ru.js';

export type Locale = 'ru' | 'en';

const catalogs: Record<Locale, Record<string, string>> = { en, ru };

let currentLocale: Locale = 'ru';

export function setLocale(locale: Locale) {
  currentLocale = locale;
}

export function getLocale(): Locale {
  return currentLocale;
}

export function t(key: string, params?: Record<string, string | number>): string {
  const message = catalogs[currentLocale][key] ?? key;
  if (!params) return message;
  return Object.entries(params).reduce((acc, [k, v]) => acc.replace(`{${k}}`, String(v)), message);
}
